// Module
var code = "<div ac-treeview=\"$ctrl.config\" ac-treeview-service=\"$ctrl.service\" style=\"margin-left:20px\"></div> ";
// Exports
module.exports = code;